import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import { AuthGate } from './auth/AuthGate.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Branchworks editor: missing #root element in index.html');

createRoot(root).render(
  <React.StrictMode>
    <AuthGate>
      <App />
    </AuthGate>
  </React.StrictMode>
);
